import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import Header from '../components/Header_log';
import '../styles/YearSelection.css';

function YearSelection() {
  const [years, setYears] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    if (!currentUser) {
      navigate('/login');
      return;
    }

    async function fetchAvailableYears() {
      try {
        const response = await axios.get(`${baseUrl}/api/available-years`);
        // Garante 2026 listado mesmo com zero respostas, mesclando e ordenando desc.
        const fallbackYears = [2024, 2025, 2026];
        const merged = Array.from(new Set([...(response.data.years || []), ...fallbackYears]))
          .sort((a, b) => b - a);
        setYears(merged);
        setLoading(false);
      } catch (err) {
        console.error('Erro ao buscar anos disponíveis:', err);
        setError('Erro ao carregar os anos disponíveis.');
        setLoading(false);
      }
    }

    fetchAvailableYears();
  }, [currentUser, navigate, baseUrl]);

  const handleSelectYear = (year) => {
    navigate(`/painel/${year}`);
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Erro ao realizar logout:', error);
    }
  };

  if (loading) return <div className="loading">Carregando...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="year-selection-container">
      <div className="no-print">
        <Header
          selectedUnit="Seleção de Ano"
          handleUnitChange={null}
          showUnitSelector={false}
          handleLogout={handleLogout}
        />
      </div>

      <div className="year-selection-content">
        <div className="year-selection-card">
          <h1>Selecione o Ano</h1>
          <p>Escolha o ano que deseja visualizar os dados da pesquisa:</p>

          {years.length === 0 ? (
            <div className="no-data">
              <p>Nenhum dado disponível para exibição.</p>
            </div>
          ) : (
            <div className="years-grid">
              {years.map((year) => (
                <button
                  key={year}
                  className="year-button"
                  onClick={() => handleSelectYear(year)}
                >
                  <span className="year-text">{year}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default YearSelection;
